/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doctor-availability.reducer';

export const DoctorAvailabilityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const doctorAvailabilityEntity = useAppSelector(state => state.doctorAvailability.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doctorAvailabilityDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.doctorAvailability.detail.title">DoctorAvailability</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.id">Id</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.id}</dd>
          <dt>
            <span id="dayOfWeek">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.dayOfWeek">Day Of Week</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.dayOfWeek}</dd>
          <dt>
            <span id="recurrenceType">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.recurrenceType">Recurrence Type</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.recurrenceType}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.active">Active</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.cursor}</dd>
          <dt>
            <span id="startTime">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.startTime">Start Time</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.startTime}</dd>
          <dt>
            <span id="endTime">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.endTime">End Time</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.endTime}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.endDate}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="suspended">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.suspended">Suspended</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.suspended ? 'true' : 'false'}</dd>
          <dt>
            <span id="enforceSchedule">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.enforceSchedule">Enforce Schedule</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.enforceSchedule ? 'true' : 'false'}</dd>
          <dt>
            <span id="consultType">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.consultType">Consult Type</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.consultType}</dd>
          <dt>
            <span id="NoOfAppts">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.NoOfAppts">No Of Appts</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.NoOfAppts}</dd>
          <dt>
            <span id="NoOfSlotsForSchedule">
              <Translate contentKey="tinyMedicRestApp.doctorAvailability.NoOfSlotsForSchedule">No Of Slots For Schedule</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilityEntity.NoOfSlotsForSchedule}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorAvailability.doctorId">Doctor Id</Translate>
          </dt>
          <dd>{doctorAvailabilityEntity.doctorId ? doctorAvailabilityEntity.doctorId.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorAvailability.hospital">Hospital</Translate>
          </dt>
          <dd>{doctorAvailabilityEntity.hospital ? doctorAvailabilityEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/doctor-availability" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doctor-availability/${doctorAvailabilityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoctorAvailabilityDetail;
